import React from "react";
import { ContextDatasection, PillConfiguration, PillOption, PillInput } from "uxp/components";
import { getContext, IContextData, IContextSchemaProps } from "../../../hooks/useContextData";


export function getPillConfiguration(customPillConfiguration?: PillConfiguration) {

    function renderValue(value: string, allFields: PillOption[]) {
        const field = allFields.find(f => f?.value == value)
        if (field) return field.label
        return value
    }

    const pillConfiguration: PillConfiguration = {
        params: {
            valueIndex: 0,
            renderValue: renderValue,
            icon: 'fas sliders-h',
            backgroundColor: '#3B82F6', // Blue
            textColor: '#FFFFFF',
        },
        datasources: {
            valueIndex: 0,
            renderValue: renderValue,
            icon: 'fas database',
            backgroundColor: '#10B981', // Green
            textColor: '#FFFFFF',
        },
        form: {
            valueIndex: 0,
            renderValue: renderValue,
            icon: 'fas font',
            backgroundColor: '#8B5CF6', // Purple
            textColor: '#FFFFFF',
        },
        filters: {
            valueIndex: 0,
            renderValue: renderValue,
            icon: 'fas filter',
            backgroundColor: '#F59E0B', // Orange
            textColor: '#FFFFFF',
        },
        theme: {
            valueIndex: 0,
            renderValue: renderValue,
            icon: 'fas palette',
            backgroundColor: '#EC4899', // Pink
            textColor: '#FFFFFF',
        },
        row: {
            valueIndex: 0,
            renderValue: renderValue,
            icon: 'fas receipt',
            backgroundColor: '#6B7280', // Gray
            textColor: '#FFFFFF',
        },
        user: {
            valueIndex: 0,
            renderValue: renderValue,
            icon: 'fas user',
            backgroundColor: '#0EA5E9', // Sky blue
            textColor: '#FFFFFF',
        },
        ...customPillConfiguration || {}
    }

    return pillConfiguration;
}

export function getContextDataSections(
    contextData: IContextData,
    showFields?: boolean,
    showThemes?: boolean,
    customContextValues?: IContextSchemaProps[]
) {
    const _contextData = getContext(contextData)
    const contextDataSections: ContextDatasection[] = [
        _contextData?.__schema__?.params,
        ...(customContextValues || []),
        ..._contextData?.__schema__?.sources || []
    ];
    if (showFields) {
        contextDataSections.push(
            _contextData?.__schema__?.fields?.form,
            _contextData?.__schema__?.fields?.filters
        );
    }
    if (showThemes) contextDataSections.push(_contextData?.__schema__?.theme);
    contextDataSections.push(_contextData?.__schema__?.user);

    return contextDataSections.filter(s => !!s);
}
export interface IWidgetDesignerPillInputProps {
    contextData: IContextData
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
    showFields?: boolean,
    showThemes?: boolean,
    customContextValues?: IContextSchemaProps[]
}

export const WidgetDesignerPillInput: React.VFC<IWidgetDesignerPillInputProps> = ({ contextData, value, onChange, placeholder, className, showFields, showThemes, customContextValues }) => {

    return <PillInput
        value={value}
        onChange={onChange}
        contextDataSections={getContextDataSections(contextData, showFields, showThemes, customContextValues)}
        pillConfiguration={getPillConfiguration()}
        className={className}
        placeholder={placeholder}
    />

}
